import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "sc-water-mark",
    ref: "scWaterMark"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return _openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512);
}
